// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import VerticalScroll from "./VerticalScroll";
// import axios from "axios";
// import { useCart } from "../../../Context/CartContext";
// import FooterCalendar from "../../Layout/FooterCalendar";

// const BASE_URL = "https://ecom.cyberathon.com";

// function Function_Cart10() {
//   const leftRef = useRef(null);
//   const [leftHeight, setLeftHeight] = useState(600);
//   const [cartItems, setCartItems] = useState([]);
//   const [cartToken, setCartToken] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [localQuantities, setLocalQuantities] = useState({});

//   const userId = sessionStorage.getItem("userId");
//   const navigate = useNavigate();

//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

//   const [orderSummary, setOrderSummary] = useState({
//     subtotal: "0.00",
//     shipping: "0.00",
//     grandTotal: "0.00"
//   });

//   // 1️⃣ Guest Token Creation
//   useEffect(() => {
//     if (!userId) {
//       let token = localStorage.getItem("cart_token");
//       if (!token) {
//         token =
//           "guest_" +
//           Date.now() +
//           "_" +
//           Math.random().toString(36).substr(2, 9);
//         localStorage.setItem("cart_token", token);
//       }
//       setCartToken(token);
//     } else {
//       setCartToken(null);
//     }
//   }, [userId]);

//   // 2️⃣ Fetch Cart
//   const fetchCart = async () => {
//     if (isUpdating) return;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken
//       });

//       if (res.data.status) {
//         const items = res.data.cart_items.map(item => ({
//           ...item,
//           cart_id: String(item.cart_id),
//           quantity: Number(item.cart_qty) || 1,
//           current_price: Number(item.current_price),
//           item_total: Number(item.current_price * item.cart_qty).toFixed(2)
//         }));

//         setCartItems(items);
//         setCartCount(items.length);
//         setOrderSummary({
//           subtotal: res.data.subtotal,
//           shipping: res.data.shipping_total,
//           grandTotal: res.data.grand_total
//         });
//       } else {
//         setCartItems([]);
//         setCartCount(0);
//         setOrderSummary({
//           subtotal: "0.00",
//           shipping: "0.00",
//           grandTotal: "0.00"
//         });
//       }
//     } catch (err) {
//       console.error("Cart fetch error:", err);
//       setCartItems([]);
//       setCartCount(0);
//     }
//   };

//   useEffect(() => {
//     if (!userId && !cartToken) return;
//     fetchCart();
//   }, [userId, cartToken]);

//   // 3️⃣ Auto refresh after login
//   useEffect(() => {
//     const onStorage = () => {
//       const uid = sessionStorage.getItem("userId");
//       if (uid) {
//         fetchCart();
//       }
//     };
//     window.addEventListener("storage", onStorage);
//     return () => window.removeEventListener("storage", onStorage);
//   }, []);

//   // 4️⃣ Height sync
//   useEffect(() => {
//     if (leftRef.current) {
//       setLeftHeight(leftRef.current.scrollHeight + 20);
//     }
//   }, [cartItems]);

//   // 5️⃣ Update Quantity
//   const updateQuantity = async (cart_id, qty) => {
//     if (qty < 1) return;

//     setIsUpdating(true);

//     try {
//       // Backend update
//       await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//         cart_id,
//         qty,
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken
//       });

//       // Fetch fresh cart
//       await fetchCart();
//     } catch (err) {
//       console.error("Quantity update error:", err);
//       await fetchCart();
//     } finally {
//       setIsUpdating(false);
//     }
//   };

//   // 5.5️⃣ Handle input change
//   const handleQuantityChange = (cart_id, value) => {
//     setLocalQuantities(prev => ({
//       ...prev,
//       [cart_id]: value
//     }));
//   };

//   // 5.6️⃣ Handle blur
//   const handleQuantityBlur = (cart_id) => {
//     const newQty = parseInt(localQuantities[cart_id]);
//     if (newQty && newQty > 0) {
//       updateQuantity(cart_id, newQty);
//     }

//     setLocalQuantities(prev => {
//       const updated = { ...prev };
//       delete updated[cart_id];
//       return updated;
//     });
//   };

//   // 6️⃣ Remove Item
//   const removeItem = async (cart_id) => {
//     try {
//       await axios.post(`${BASE_URL}/index.php/Api/delete_cart`, {
//         cart_id,
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken
//       });
//       await fetchCart();
//     } catch (err) {
//       console.error("Delete cart error:", err);
//     }
//   };

//   // 7️⃣ Sync pending quantities before buy
//   const syncPendingQuantities = async () => {
//     const entries = Object.entries(localQuantities);
//     if (entries.length === 0) return;

//     for (const [cart_id, qty] of entries) {
//       const parsedQty = parseInt(qty);
//       if (parsedQty > 0) {
//         await updateQuantity(cart_id, parsedQty);
//       }
//     }
//     setLocalQuantities({});
//   };

//   const handleProceedToBuy = async () => {
//     await syncPendingQuantities();
//     if (userId) {
//       navigate("/Bill");
//     } else {
//       setRedirectAfterLogin("/Bill");
//       setShowLogin(true);
//     }
//   };

//   return (
//     <>
//     <Layout/>
//       <div className="container py-5">
//         <div className="row g-4">
//           <h2 className="fw-bold mb-3">Shopping Cart</h2>

//           <div className="col-md-8" ref={leftRef}>
//             {cartItems.length === 0 ? (
//               <p>Your cart is empty.</p>
//             ) : (
//               cartItems.map(item => (
//                 <div key={item.cart_id} className="card p-3 mb-3 shadow-sm">
//                   <div className="d-flex justify-content-between">
//                     <div className="d-flex gap-3">
//                       <img
//                         src={`${BASE_URL}/${item.Product_image}`}
//                         alt={item.Product_name}
//                         style={{ width: 120, height: 120, objectFit: "contain" }}
//                       />
//                       <div>
//                         <h5>{item.Product_name}</h5>
//                         <div className="d-flex gap-3 align-items-center mt-2">
//                           <div className="d-flex align-items-center border rounded">
//                             <button
//                               className="btn btn-sm border-0 px-2"
//                               disabled={isUpdating || item.quantity <= 1}
//                               onClick={() =>
//                                 updateQuantity(item.cart_id, item.quantity - 1)
//                               }
//                             >
//                               -
//                             </button>

//                             <input
//                               type="number"
//                               min="1"
//                               value={localQuantities[item.cart_id] ?? item.quantity}
//                               className="form-control text-center border-0 quantity-input"
//                               style={{ width: "50px" }}
//                               onChange={(e) => handleQuantityChange(item.cart_id, e.target.value)}
//                               onBlur={() => handleQuantityBlur(item.cart_id)}
//                               onKeyPress={(e) => e.key === 'Enter' && e.target.blur()}
//                               onWheel={(e) => e.target.blur()}
//                             />

//                             <button
//                               className="btn btn-sm border-0 px-2"
//                               disabled={isUpdating}
//                               onClick={() =>
//                                 updateQuantity(item.cart_id, item.quantity + 1)
//                               }
//                             >
//                               +
//                             </button>
//                           </div>
//                           <button
//                             className="btn btn-link text-danger p-0"
//                             onClick={() => removeItem(item.cart_id)}
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                     <b>₹ {Number(item.item_total).toFixed(2)}</b>
//                   </div>
//                 </div>
//               ))
//             )}

//             {cartItems.length > 0 && (
//               <div className="d-flex justify-content-between border-top pt-3">
//                 <div>
//                   <div className="d-flex justify-content-start gap-2 mb-3 pt-2">
//                     <h5>Subtotal:</h5>
//                     <h5 className="text-success">₹ {orderSummary.subtotal}</h5>
//                   </div>
//                 </div>

//                 <button
//                   className="px-md-2 px-1 btn text-light fw-bold"
//                   style={{ background: "#24aeb1" }}
//                   onClick={handleProceedToBuy}
//                 >
//                   Proceed to Buy ({cartItems.length} items)
//                 </button>
//               </div>
//             )}
//           </div>

//           <VerticalScroll dynamicHeight={leftHeight} />
//         </div>
//       </div>
//     <FooterCalendar/>
//     </>
//   );
// }

// export default Function_Cart10;

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import VerticalScroll from "./VerticalScroll";
// import axios from "axios";
// import { useCart } from "../../../Context/CartContext";
// import FooterCalendar from "../../Layout/FooterCalendar";

// const BASE_URL = "https://ecom.cyberathon.com";

// function Function_Cart10() {
//   const leftRef = useRef(null);
//   const [leftHeight, setLeftHeight] = useState(600);
//   const [cartItems, setCartItems] = useState([]);
//   const [cartToken, setCartToken] = useState(null);
//   const [localQuantities, setLocalQuantities] = useState({});

//   const userId = sessionStorage.getItem("userId");
//   const navigate = useNavigate();

//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

//   /* ===================== GUEST TOKEN ===================== */
//   useEffect(() => {
//     if (!userId) {
//       let token = localStorage.getItem("cart_token");
//       if (!token) {
//         token = "guest_" + Date.now() + "_" + Math.random().toString(36).slice(2);
//         localStorage.setItem("cart_token", token);
//       }
//       setCartToken(token);
//     } else {
//       setCartToken(null);
//     }
//   }, [userId]);

//   /* ===================== FETCH CART ===================== */
//   const fetchCart = async () => {
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId || null,
//         cart_token: userId ? null : cartToken
//       });

//       if (res.data.status) {
//         const items = res.data.cart_items.map(item => ({
//           ...item,
//           cart_id: String(item.cart_id),
//           quantity: Number(item.cart_qty),
//           current_price: Number(item.current_price)
//         }));

//         setCartItems(items);
//         setCartCount(items.length);
//       } else {
//         setCartItems([]);
//         setCartCount(0);
//       }
//     } catch (err) {
//       console.error("Fetch cart error", err);
//     }
//   };

//   useEffect(() => {
//     if (!userId && !cartToken) return;
//     fetchCart();
//   }, [userId, cartToken]);

//   /* ===================== HEIGHT SYNC ===================== */
//   useEffect(() => {
//     if (leftRef.current) {
//       setLeftHeight(leftRef.current.scrollHeight + 20);
//     }
//   }, [cartItems, localQuantities]);

//   /* ===================== QUANTITY HANDLERS ===================== */

//   const handleQuantityChange = (cart_id, value) => {
//     if (value < 1) return;
//     setLocalQuantities(prev => ({
//       ...prev,
//       [cart_id]: Number(value)
//     }));
//   };

//   const updateQuantity = async (cart_id, qty) => {
//     try {
//       await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//         cart_id,
//         qty,
//         user_id: userId || null,
//         cart_token: userId ? null : cartToken
//       });
//       fetchCart();
//     } catch (err) {
//       console.error("Update qty error", err);
//     }
//   };

//   const handleQuantityBlur = (cart_id) => {
//     const qty = localQuantities[cart_id];
//     if (qty) updateQuantity(cart_id, qty);

//     setLocalQuantities(prev => {
//       const copy = { ...prev };
//       delete copy[cart_id];
//       return copy;
//     });
//   };

//   /* ===================== REMOVE ITEM ===================== */
//   const removeItem = async (cart_id) => {
//     try {
//       await axios.post(`${BASE_URL}/index.php/Api/delete_cart`, {
//         cart_id,
//         user_id: userId || null,
//         cart_token: userId ? null : cartToken
//       });
//       fetchCart();
//     } catch (err) {
//       console.error("Delete error", err);
//     }
//   };

//   /* ===================== SUBTOTAL CALC ===================== */
//   const calculatedSubtotal = cartItems.reduce((sum, item) => {
//     const qty = localQuantities[item.cart_id] ?? item.quantity;
//     return sum + qty * item.current_price;
//   }, 0);

//   /* ===================== PROCEED ===================== */
//   const handleProceedToBuy = async () => {
//     for (const [cart_id, qty] of Object.entries(localQuantities)) {
//       await updateQuantity(cart_id, qty);
//     }
//     setLocalQuantities({});

//     if (userId) {
//       navigate("/Bill");
//     } else {
//       setRedirectAfterLogin("/Bill");
//       setShowLogin(true);
//     }
//   };

//   return (
//     <>
//       <Layout />
//       <div className="container py-5">
//         <h2 className="fw-bold mb-3">Shopping Cart</h2>

//         <div className="row g-4">
//           <div className="col-md-8" ref={leftRef}>
//             {cartItems.length === 0 ? (
//               <p>Your cart is empty.</p>
//             ) : (
//               cartItems.map(item => {
//                 const qty = localQuantities[item.cart_id] ?? item.quantity;
//                 const itemTotal = qty * item.current_price;

//                 return (
//                   <div key={item.cart_id} className="card p-3 mb-3 shadow-sm">
//                     <div className="d-flex justify-content-between">
//                       <div className="d-flex gap-3">
//                         <img
//                           src={`${BASE_URL}/${item.Product_image}`}
//                           alt={item.Product_name}
//                           style={{ width: 120, height: 120, objectFit: "contain" }}
//                         />

//                         <div>
//                           <h5>{item.Product_name}</h5>

//                           <div className="d-flex gap-3 align-items-center mt-2">
//                             <div className="d-flex align-items-center border rounded">
//                               <button
//                                 className="btn btn-sm px-2"
//                                 onClick={() =>
//                                   handleQuantityChange(item.cart_id, qty - 1)
//                                 }
//                                 disabled={qty <= 1}
//                               >
//                                 -
//                               </button>

//                               <input
//                                 type="number"
//                                 min="1"
//                                 value={qty}
//                                 className="form-control text-center border-0"
//                                 style={{ width: 50 }}
//                                 onChange={(e) =>
//                                   handleQuantityChange(item.cart_id, e.target.value)
//                                 }
//                                 onBlur={() => handleQuantityBlur(item.cart_id)}
//                               />

//                               <button
//                                 className="btn btn-sm px-2"
//                                 onClick={() =>
//                                   handleQuantityChange(item.cart_id, qty + 1)
//                                 }
//                               >
//                                 +
//                               </button>
//                             </div>

//                             <button
//                               className="btn btn-link text-danger p-0"
//                               onClick={() => removeItem(item.cart_id)}
//                             >
//                               Delete
//                             </button>
//                           </div>
//                         </div>
//                       </div>

//                       <b>₹ {itemTotal.toFixed(2)}</b>
//                     </div>
//                   </div>
//                 );
//               })
//             )}

//             {cartItems.length > 0 && (
//               <div className="d-flex justify-content-between border-top pt-3">
//                 <h5 className="text-success">
//                   Subtotal: ₹ {calculatedSubtotal.toFixed(2)}
//                 </h5>

//                 <button
//                   className="btn text-light fw-bold"
//                   style={{ background: "#24aeb1" }}
//                   onClick={handleProceedToBuy}
//                 >
//                   Proceed to Buy ({cartItems.length})
//                 </button>
//               </div>
//             )}
//           </div>

//           <VerticalScroll dynamicHeight={leftHeight} />
//         </div>
//       </div>
//       <FooterCalendar />
//     </>
//   );
// }

// export default Function_Cart10;

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import VerticalScroll from "./VerticalScroll";
// import axios from "axios";
// import { useCart } from "../../../Context/CartContext";
// import FooterCalendar from "../../Layout/FooterCalendar";

// const BASE_URL = "https://ecom.cyberathon.com";

// function Function_Cart10() {
//   const leftRef = useRef(null);
//   const debounceTimers = useRef({});

//   const [leftHeight, setLeftHeight] = useState(600);
//   const [cartItems, setCartItems] = useState([]);
//   const [cartToken, setCartToken] = useState(null);
//   const [localQuantities, setLocalQuantities] = useState({});

//   const userId = sessionStorage.getItem("userId");
//   const navigate = useNavigate();

//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

//   /* ===================== GUEST TOKEN ===================== */
//   useEffect(() => {
//     if (!userId) {
//       let token = localStorage.getItem("cart_token");
//       if (!token) {
//         token =
//           "guest_" + Date.now() + "_" + Math.random().toString(36).slice(2);
//         localStorage.setItem("cart_token", token);
//       }
//       setCartToken(token);
//     } else {
//       setCartToken(null);
//     }
//   }, [userId]);

//   /* ===================== FETCH CART ===================== */
//   const fetchCart = async () => {
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId || null,
//         cart_token: userId ? null : cartToken
//       });

//       if (res.data.status) {
//         const items = res.data.cart_items.map(item => ({
//           ...item,
//           cart_id: String(item.cart_id),
//           quantity: Number(item.cart_qty),
//           current_price: Number(item.current_price)
//         }));

//         setCartItems(items);
//         setCartCount(items.length);
//       } else {
//         setCartItems([]);
//         setCartCount(0);
//       }
//     } catch (err) {
//       console.error("Fetch cart error:", err);
//     }
//   };

//   useEffect(() => {
//     if (!userId && !cartToken) return;
//     fetchCart();
//   }, [userId, cartToken]);

//   /* ===================== HEIGHT SYNC ===================== */
//   useEffect(() => {
//     if (leftRef.current) {
//       setLeftHeight(leftRef.current.scrollHeight + 20);
//     }
//   }, [cartItems, localQuantities]);

//   /* ===================== UPDATE QTY API ===================== */
//   const updateQuantity = async (cart_id, qty) => {
//     try {
//       await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//         cart_id,
//         qty,
//         user_id: userId || null,
//         cart_token: userId ? null : cartToken
//       });
//       fetchCart(); // backend subtotal refresh
//     } catch (err) {
//       console.error("Update qty error:", err);
//     }
//   };

//   /* ===================== QTY CHANGE (DEBOUNCED) ===================== */
//   const handleQuantityChange = (cart_id, value) => {
//     if (value < 1) return;

//     const qty = Number(value);

//     // UI instant update
//     setLocalQuantities(prev => ({
//       ...prev,
//       [cart_id]: qty
//     }));

//     // clear previous debounce
//     if (debounceTimers.current[cart_id]) {
//       clearTimeout(debounceTimers.current[cart_id]);
//     }

//     // backend update after delay
//     debounceTimers.current[cart_id] = setTimeout(() => {
//       updateQuantity(cart_id, qty);
//     }, 600);
//   };

//   /* ===================== BLUR CLEANUP ===================== */
//   const handleQuantityBlur = (cart_id) => {
//     if (debounceTimers.current[cart_id]) {
//       clearTimeout(debounceTimers.current[cart_id]);
//       delete debounceTimers.current[cart_id];
//     }

//     setLocalQuantities(prev => {
//       const copy = { ...prev };
//       delete copy[cart_id];
//       return copy;
//     });
//   };

//   /* ===================== REMOVE ITEM ===================== */
//   const removeItem = async (cart_id) => {
//     try {
//       await axios.post(`${BASE_URL}/index.php/Api/delete_cart`, {
//         cart_id,
//         user_id: userId || null,
//         cart_token: userId ? null : cartToken
//       });
//       fetchCart();
//     } catch (err) {
//       console.error("Delete cart error:", err);
//     }
//   };

//   /* ===================== SUBTOTAL ===================== */
//   const calculatedSubtotal = cartItems.reduce((sum, item) => {
//     const qty = localQuantities[item.cart_id] ?? item.quantity;
//     return sum + qty * item.current_price;
//   }, 0);

//   /* ===================== PROCEED ===================== */
//   const handleProceedToBuy = async () => {
//     // force-save any pending qty
//     for (const [cart_id, qty] of Object.entries(localQuantities)) {
//       await updateQuantity(cart_id, qty);
//     }
//     setLocalQuantities({});

//     if (userId) {
//       navigate("/Bill");
//     } else {
//       setRedirectAfterLogin("/Bill");
//       setShowLogin(true);
//     }
//   };

//   return (
//     <>
//       <Layout />

//       <div className="container py-5">
//         <h2 className="fw-bold mb-3">Shopping Cart</h2>

//         <div className="row g-4">
//           <div className="col-md-8" ref={leftRef}>
//             {cartItems.length === 0 ? (
//               <p>Your cart is empty.</p>
//             ) : (
//               cartItems.map(item => {
//                 const qty =
//                   localQuantities[item.cart_id] ?? item.quantity;
//                 const itemTotal = qty * item.current_price;

//                 return (
//                   <div key={item.cart_id} className="card p-3 mb-3 shadow-sm">
//                     <div className="d-flex justify-content-between">
//                       <div className="d-flex gap-3">
//                         <img
//                           src={`${BASE_URL}/${item.Product_image}`}
//                           alt={item.Product_name}
//                           style={{
//                             width: 120,
//                             height: 120,
//                             objectFit: "contain"
//                           }}
//                         />

//                         <div>
//                           <h5>{item.Product_name}</h5>

//                           <div className="d-flex gap-3 align-items-center mt-2">
//                             <div className="d-flex align-items-center border rounded">
//                               <button
//                                 className="btn btn-sm px-2"
//                                 disabled={qty <= 1}
//                                 onClick={() =>
//                                   handleQuantityChange(
//                                     item.cart_id,
//                                     qty - 1
//                                   )
//                                 }
//                               >
//                                 -
//                               </button>

//                               <input
//                                 type="number"
//                                 min="1"
//                                 value={qty}
//                                 className="form-control text-center border-0"
//                                 style={{ width: 50 }}
//                                 onChange={(e) =>
//                                   handleQuantityChange(
//                                     item.cart_id,
//                                     e.target.value
//                                   )
//                                 }
//                                 onBlur={() =>
//                                   handleQuantityBlur(item.cart_id)
//                                 }
//                               />

//                               <button
//                                 className="btn btn-sm px-2"
//                                 onClick={() =>
//                                   handleQuantityChange(
//                                     item.cart_id,
//                                     qty + 1
//                                   )
//                                 }
//                               >
//                                 +
//                               </button>
//                             </div>

//                             <button
//                               className="btn btn-link text-danger p-0"
//                               onClick={() =>
//                                 removeItem(item.cart_id)
//                               }
//                             >
//                               Delete
//                             </button>
//                           </div>
//                         </div>
//                       </div>

//                       <b>₹ {itemTotal.toFixed(2)}</b>
//                     </div>
//                   </div>
//                 );
//               })
//             )}

//             {cartItems.length > 0 && (
//               <div className="d-flex justify-content-between border-top pt-3">
//                 <h5 className="text-success">
//                   Subtotal: ₹ {calculatedSubtotal.toFixed(2)}
//                 </h5>

//                 <button
//                   className="btn text-light fw-bold"
//                   style={{ background: "#24aeb1" }}
//                   onClick={handleProceedToBuy}
//                 >
//                   Proceed to Buy ({cartItems.length})
//                 </button>
//               </div>
//             )}
//           </div>

//           <VerticalScroll dynamicHeight={leftHeight} />
//         </div>
//       </div>

//       <FooterCalendar />
//     </>
//   );
// }

// export default Function_Cart10;

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import VerticalScroll from "./VerticalScroll";
// import axios from "axios";
// import { useCart } from "../../../Context/CartContext";
// import FooterCalendar from "../../Layout/FooterCalendar";

// const BASE_URL = "https://ecom.cyberathon.com";

// function Function_Cart10() {
//   const leftRef = useRef(null);
//   const debounceTimers = useRef({});

//   const [leftHeight, setLeftHeight] = useState(600);
//   const [cartItems, setCartItems] = useState([]);
//   const [localQuantities, setLocalQuantities] = useState({});

//   const userId = sessionStorage.getItem("userId");
//   const navigate = useNavigate();
//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

//   /* ================= FETCH CART ================= */
//   const fetchCart = async () => {
//     const res = await axios.post(
//       `${BASE_URL}/index.php/Api/list_cart`,
//       { user_id: userId }
//     );

//     if (res.data.status) {
//       const items = res.data.cart_items.map(item => ({
//         ...item,
//         quantity: Number(item.cart_qty),
//         current_price: Number(item.current_price),
//         prod_id: Number(item.prod_id) // 🔥 IMPORTANT
//       }));

//       setCartItems(items);
//       setCartCount(items.length);
//     } else {
//       setCartItems([]);
//       setCartCount(0);
//     }
//   };

//   useEffect(() => {
//     if (userId) fetchCart();
//   }, [userId]);

//   /* ================= HEIGHT SYNC ================= */
//   useEffect(() => {
//     if (leftRef.current) {
//       setLeftHeight(leftRef.current.scrollHeight + 20);
//     }
//   }, [cartItems, localQuantities]);

//   /* ================= UPDATE QTY API ================= */
//   const updateQuantity = async (prod_id, qty) => {
//     await axios.post(
//       `${BASE_URL}/index.php/Api/update_cart`,
//       {
//         user_id: userId,
//         prod_id: prod_id,
//         qty: qty
//       }
//     );
//     fetchCart(); // backend subtotal refresh
//   };

//   /* ================= QTY CHANGE (DEBOUNCE) ================= */
//   const handleQuantityChange = (prod_id, value) => {
//     if (value < 1) return;

//     const qty = Number(value);

//     // instant UI
//     setLocalQuantities(prev => ({
//       ...prev,
//       [prod_id]: qty
//     }));

//     // debounce clear
//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//     }

//     debounceTimers.current[prod_id] = setTimeout(() => {
//       updateQuantity(prod_id, qty);
//     }, 600);
//   };

//   const handleQuantityBlur = (prod_id) => {
//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//       delete debounceTimers.current[prod_id];
//     }

//     setLocalQuantities(prev => {
//       const copy = { ...prev };
//       delete copy[prod_id];
//       return copy;
//     });
//   };

//   /* ================= REMOVE ITEM ================= */
//   const removeItem = async (prod_id) => {
//     await axios.post(
//       `${BASE_URL}/index.php/Api/delete_cart`,
//       {
//         user_id: userId,
//         prod_id: prod_id
//       }
//     );
//     fetchCart();
//   };

//   /* ================= SUBTOTAL (UI) ================= */
//   const calculatedSubtotal = cartItems.reduce((sum, item) => {
//     const qty = localQuantities[item.prod_id] ?? item.quantity;
//     return sum + qty * item.current_price;
//   }, 0);

//   /* ================= PROCEED ================= */
//   const handleProceedToBuy = async () => {
//     for (const [prod_id, qty] of Object.entries(localQuantities)) {
//       await updateQuantity(prod_id, qty);
//     }
//     setLocalQuantities({});

//     if (userId) {
//       navigate("/Bill");
//     } else {
//       setRedirectAfterLogin("/Bill");
//       setShowLogin(true);
//     }
//   };

//   return (
//     <>
//       <Layout />

//       <div className="container py-5">
//         <h2 className="fw-bold mb-3">Shopping Cart</h2>

//         <div className="row g-4">
//           <div className="col-md-8" ref={leftRef}>
//             {cartItems.map(item => {
//               const qty =
//                 localQuantities[item.prod_id] ?? item.quantity;
//               const itemTotal = qty * item.current_price;

//               return (
//                 <div key={item.prod_id} className="card p-3 mb-3 shadow-sm">
//                   <div className="d-flex justify-content-between">
//                     <div className="d-flex gap-3">
//                       <img
//                         src={`${BASE_URL}/${item.Product_image}`}
//                         alt={item.Product_name}
//                         style={{ width: 120, height: 120 }}
//                       />

//                       <div>
//                         <h5>{item.Product_name}</h5>

//                         <div className="d-flex gap-3 mt-2">
//                           <button
//                             onClick={() =>
//                               handleQuantityChange(item.prod_id, qty - 1)
//                             }
//                             disabled={qty <= 1}
//                           >
//                             -
//                           </button>

//                           <input
//                             type="number"
//                             value={qty}
//                             onChange={(e) =>
//                               handleQuantityChange(
//                                 item.prod_id,
//                                 e.target.value
//                               )
//                             }
//                             onBlur={() =>
//                               handleQuantityBlur(item.prod_id)
//                             }
//                             style={{ width: 50 }}
//                           />

//                           <button
//                             onClick={() =>
//                               handleQuantityChange(item.prod_id, qty + 1)
//                             }
//                           >
//                             +
//                           </button>

//                           <button
//                             className="text-danger"
//                             onClick={() =>
//                               removeItem(item.prod_id)
//                             }
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </div>
//                     </div>

//                     <b>₹ {itemTotal.toFixed(2)}</b>
//                   </div>
//                 </div>
//               );
//             })}

//             <h5 className="text-success">
//               Subtotal: ₹ {calculatedSubtotal.toFixed(2)}
//             </h5>

//             <button
//               className="btn text-light"
//               style={{ background: "#24aeb1" }}
//               onClick={handleProceedToBuy}
//             >
//               Proceed to Buy
//             </button>
//           </div>

//           <VerticalScroll dynamicHeight={leftHeight} />
//         </div>
//       </div>

//       <FooterCalendar />
//     </>
//   );
// }

// export default Function_Cart10;

// corrected code

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import VerticalScroll from "./VerticalScroll";
// import axios from "axios";
// import { useCart } from "../../../Context/CartContext";
// import FooterCalendar from "../../Layout/FooterCalendar";

// const BASE_URL = "https://ecom.cyberathon.com";

// function Function_Cart10() {
//   const leftRef = useRef(null);
//   const debounceTimers = useRef({});

//   const [leftHeight, setLeftHeight] = useState(600);
//   const [cartItems, setCartItems] = useState([]);
//   const [localQty, setLocalQty] = useState({});

//   const userId = sessionStorage.getItem("userId");
//   const navigate = useNavigate();
//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

//   /* ================= FETCH CART ================= */
//   const fetchCart = async () => {
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/list_cart`,
//         { user_id: userId }
//       );

//       if (res.data.status) {
//         const items = res.data.cart_items.map(item => ({
//           ...item,
//           prod_id: Number(item.prod_id),
//           quantity: Number(item.cart_qty),
//           price: Number(item.current_price)
//         }));

//         setCartItems(items);
//         setCartCount(items.length);
//       }
//     } catch (err) {
//       console.error("fetch cart error", err);
//     }
//   };

//   useEffect(() => {
//     if (userId) fetchCart();
//   }, [userId]);

//   /* ================= HEIGHT ================= */
//   useEffect(() => {
//     if (leftRef.current) {
//       setLeftHeight(leftRef.current.scrollHeight + 20);
//     }
//   }, [cartItems, localQty]);

//   /* ================= UPDATE QTY API ================= */
//   const updateQuantity = async (prod_id, qty) => {
//     await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//       user_id: userId,
//       prod_id,
//       qty
//     });
//     fetchCart(); // refresh subtotal from backend
//   };

//   /* ================= CHANGE QTY (DEBOUNCE) ================= */
//   const changeQty = (prod_id, qty) => {
//     if (qty < 1) return;

//     // instant UI
//     setLocalQty(prev => ({ ...prev, [prod_id]: qty }));

//     // debounce backend
//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//     }

//     debounceTimers.current[prod_id] = setTimeout(() => {
//       updateQuantity(prod_id, qty);
//     }, 500);
//   };

//   /* ================= BLUR ================= */
//   const handleBlur = (prod_id) => {
//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//       delete debounceTimers.current[prod_id];
//     }

//     setLocalQty(prev => {
//       const copy = { ...prev };
//       delete copy[prod_id];
//       return copy;
//     });
//   };

//   /* ================= REMOVE ================= */
// //   const removeItem = async (prod_id) => {
// //     await axios.post(`${BASE_URL}/index.php/Api/delete_cart`, {
// //       user_id: userId,
// //       prod_id
// //     });
// //     fetchCart();
// //   };

// const removeItem = async (prod_id) => {
//   try {
//     // 1️⃣ pending debounce cancel
//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//       delete debounceTimers.current[prod_id];
//     }

//     // 2️⃣ localQty se remove
//     setLocalQty(prev => {
//       const copy = { ...prev };
//       delete copy[prod_id];
//       return copy;
//     });

//     // 3️⃣ UI se turant remove (optional but BEST)
//     setCartItems(prev =>
//       prev.filter(item => item.prod_id !== prod_id)
//     );
//     setCartCount(prev => Math.max(prev - 1, 0));

//     // 4️⃣ backend delete (FINAL)
//     await axios.post(
//       `${BASE_URL}/index.php/Api/delete_cart`,
//       {
//         user_id: userId,
//         prod_id
//       }
//     );

//   } catch (err) {
//     console.error("delete cart error", err);
//     fetchCart(); // rollback
//   }
// };

//   /* ================= SUBTOTAL ================= */
//   const subtotal = cartItems.reduce((sum, item) => {
//     const qty = localQty[item.prod_id] ?? item.quantity;
//     return sum + qty * item.price;
//   }, 0);

//   /* ================= PROCEED ================= */
//   const handleProceed = async () => {
//     for (const [prod_id, qty] of Object.entries(localQty)) {
//       await updateQuantity(prod_id, qty);
//     }
//     setLocalQty({});

//     if (userId) navigate("/Bill");
//     else {
//       setRedirectAfterLogin("/Bill");
//       setShowLogin(true);
//     }
//   };

//   return (
//     <>
//       <Layout />

//       <div className="container py-5">
//         <h2 className="fw-bold mb-4">Shopping Cart</h2>

//         <div className="row g-4">
//           <div className="col-md-8" ref={leftRef}>
//             {cartItems.map(item => {
//               const qty = localQty[item.prod_id] ?? item.quantity;
//               const total = qty * item.price;

//               return (
//                 <div key={item.prod_id} className="card p-4 mb-3 shadow-sm">
//                   <div className="d-flex justify-content-between align-items-center">
//                     <div className="d-flex gap-3">
//                       <img
//                         src={`${BASE_URL}/${item.Product_image}`}
//                         alt={item.Product_name}
//                         style={{ width: 110, height: 110, objectFit: "contain" }}
//                       />

//                       <div>
//                         <h5>{item.Product_name}</h5>

//                         {/* ✅ EXACT UI (+ input -) */}
//                         {/* <div className="d-flex align-items-center gap-2 mt-2">
//                           <button
//                             className="btn btn-light border"
//                             onClick={() => changeQty(item.prod_id, qty - 1)}
//                             disabled={qty <= 1}
//                           >
//                             −
//                           </button>

//                           <input
//                             type="number"
//                             min="1"
//                             value={qty}
//                             onChange={(e) =>
//                               changeQty(item.prod_id, Number(e.target.value))
//                             }
//                             onBlur={() => handleBlur(item.prod_id)}
//                             className="form-control text-center"
//                             style={{ width: 60 }}
//                           />

//                           <button
//                             className="btn btn-light border"
//                             onClick={() => changeQty(item.prod_id, qty + 1)}
//                           >
//                             +
//                           </button>

//                           <button
//                             className="btn btn-link text-danger ms-3 p-0"
//                             onClick={() => removeItem(item.prod_id)}
//                           >
//                             Delete
//                           </button>
//                         </div> */}
//                         <div
//   className="d-flex align-items-center border rounded"
//   style={{ width: 120, height: 40 }}
// >
//   {/* MINUS */}
//   <button
//     className="btn btn-light border-0 fw-bold"
//     style={{ width: 35 }}
//     disabled={qty <= 1}
//     onClick={() => changeQty(item.prod_id, qty - 1)}
//   >
//     −
//   </button>

//   {/* NUMBER (NO ARROWS) */}
//   <input
//     type="text"
//     value={qty}
//     onChange={(e) => {
//       const val = e.target.value.replace(/\D/g, "");
//       if (val) changeQty(item.prod_id, Number(val));
//     }}
//     onBlur={() => handleBlur(item.prod_id)}
//     className="form-control text-center border-0"
//     style={{
//       width: 50,
//       boxShadow: "none",
//       fontWeight: "600"
//     }}
//   />

//   {/* PLUS */}
//   <button
//     className="btn btn-light border-0 fw-bold"
//     style={{ width: 35 }}
//     onClick={() => changeQty(item.prod_id, qty + 1)}
//   >
//     +
//   </button>
//   <button
//                             className="btn btn-link text-danger ms-3 p-0"
//                             onClick={() => removeItem(item.prod_id)}
//                           >
//                             Delete
//                           </button>
// </div>

//                       </div>
//                     </div>

//                     <b>₹ {total.toFixed(2)}</b>
//                   </div>
//                 </div>
//               );
//             })}

//             <div className="d-flex justify-content-between align-items-center border-top pt-3">
//               <h5 className="fw-bold text-success">
//                 Subtotal: ₹ {subtotal.toFixed(2)}
//               </h5>

//               <button
//                 className="btn text-light fw-bold px-4"
//                 style={{ background: "#24aeb1" }}
//                 onClick={handleProceed}
//               >
//                 Proceed to Buy ({cartItems.length} items)
//               </button>
//             </div>
//           </div>

//           <VerticalScroll dynamicHeight={leftHeight} />
//         </div>
//       </div>

//       <FooterCalendar />
//     </>
//   );
// }

// export default Function_Cart10;

// 03-01-2026
// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import VerticalScroll from "./VerticalScroll";
// import axios from "axios";
// import { useCart } from "../../../Context/CartContext";
// import FooterCalendar from "../../Layout/FooterCalendar";
// import FooterNew from "../../Layout/FooterNew";

// const BASE_URL = "https://ecom.cyberathon.com";

// function Function_Cart10() {
//   const leftRef = useRef(null);
//   const debounceTimers = useRef({});

//   const [leftHeight, setLeftHeight] = useState(600);
//   const [cartItems, setCartItems] = useState([]);
//   const [localQty, setLocalQty] = useState({});
//   const [cartToken, setCartToken] = useState(null);

//   const userId = sessionStorage.getItem("userId");
//   const navigate = useNavigate();
//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

//   /* ================= GUEST TOKEN ================= */
//   useEffect(() => {
//     if (!userId) {
//       let token = localStorage.getItem("cart_token");
//       if (!token) {
//         token = "guest_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
//         localStorage.setItem("cart_token", token);
//       }
//       setCartToken(token);
//     } else {
//       setCartToken(null);
//     }
//   }, [userId]);

//   /* ================= FETCH CART ================= */
//   const fetchCart = async () => {
//     const activeToken = cartToken || localStorage.getItem("cart_token");

//     if (!userId && !activeToken) return;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId || null,
//         cart_token: userId ? null : activeToken
//       });

//       if (res.data.status) {
//         const items = res.data.cart_items.map(item => ({
//           ...item,
//            cart_id: Number(item.cart_id),
//           prod_id: Number(item.prod_id),
//           quantity: Number(item.cart_qty),
//           price: Number(item.current_price)
//         }));

//         setCartItems(items);
//         setCartCount(items.length);
//       } else {
//         setCartItems([]);
//         setCartCount(0);
//       }
//     } catch (err) {
//       console.error("fetch cart error", err);
//       setCartItems([]);
//       setCartCount(0);
//     }
//   };

//   useEffect(() => {
//     if (userId || cartToken) {
//       fetchCart();
//     }
//   }, [userId, cartToken]);

//   /* ================= MERGE CART ON LOGIN ================= */
//   useEffect(() => {
//     if (userId && cartToken) {
//       axios.post(`${BASE_URL}/index.php/Api/merge_cart`, {
//         user_id: userId,
//         cart_token: cartToken
//       }).then(() => {
//         localStorage.removeItem("cart_token");
//         setCartToken(null);
//         fetchCart();
//       }).catch(err => {
//         console.error("merge cart error", err);
//       });
//     }
//   }, [userId]);

//   /* ================= HEIGHT ================= */
//   useEffect(() => {
//     if (leftRef.current) {
//       setLeftHeight(leftRef.current.scrollHeight + 20);
//     }
//   }, [cartItems, localQty]);

//   /* ================= UPDATE QTY API ================= */
//   const updateQuantity = async (prod_id, qty) => {
//     await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//       user_id: userId || null,
//       cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token")),
//       prod_id,
//       qty
//     });
//     fetchCart();
//   };

//   /* ================= CHANGE QTY (DEBOUNCE) ================= */
//   const changeQty = (prod_id, qty) => {
//     if (qty < 1) return;

//     setLocalQty(prev => ({ ...prev, [prod_id]: qty }));

//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//     }

//     debounceTimers.current[prod_id] = setTimeout(() => {
//       updateQuantity(prod_id, qty);
//     }, 500);
//   };

//   /* ================= BLUR ================= */
//   const handleBlur = (prod_id) => {
//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//       delete debounceTimers.current[prod_id];
//     }

//     setLocalQty(prev => {
//       const copy = { ...prev };
//       delete copy[prod_id];
//       return copy;
//     });
//   };

//   /* ================= REMOVE ================= */
//   const removeItem = async (prod_id) => {
//     try {
//        // 1️⃣ Find cart_id from prod_id
//     const item = cartItems.find(i => i.prod_id === prod_id);
//      console.log("🔴 DELETE - Full item object:", item);
//     console.log("🔴 DELETE - cart_id:", item?.cart_id);
//     console.log("🔴 DELETE - prod_id:", prod_id);

//     if (!item || !item.cart_id) {
//       console.error("❌ cart_id not found!");
//       return;
//     }
//     // if (!item) return;
//       if (debounceTimers.current[prod_id]) {
//         clearTimeout(debounceTimers.current[prod_id]);
//         delete debounceTimers.current[prod_id];
//       }

//       setLocalQty(prev => {
//         const copy = { ...prev };
//         delete copy[prod_id];
//         return copy;
//       });

//       setCartItems(prev => prev.filter(item => item.prod_id !== prod_id));
//       setCartCount(prev => Math.max(prev - 1, 0));

//       // await axios.post(`${BASE_URL}/index.php/Api/delete_cart`, {
//       //   user_id: userId || null,
//       //   cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token")),
//       //   // prod_id
//       // });
//        // 5️⃣ Backend delete - ✅ SEND cart_id NOT prod_id
//     const payload = {
//       cart_id: Number(item.cart_id),  // ✅ CORRECT
//       user_id: userId || null,
//       cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token"))
//     };

//     console.log("📤 Sending DELETE request:", payload);

//     const response = await axios.post(
//       `${BASE_URL}/index.php/Api/delete_cart`,
//       payload
//     );

//     console.log("📥 DELETE response:", response.data);

//     if (!response.data.status) {
//       console.error("❌ Backend delete failed:", response.data.message);
//       fetchCart(); // rollback
//     }
//     } catch (err) {
//       console.error("delete cart error", err);
//       fetchCart();
//     }
//   };

//   /* ================= SUBTOTAL ================= */
//   const subtotal = cartItems.reduce((sum, item) => {
//     const qty = localQty[item.prod_id] ?? item.quantity;
//     return sum + qty * item.price;
//   }, 0);

//   /* ================= PROCEED ================= */
//   const handleProceed = async () => {
//     for (const [prod_id, qty] of Object.entries(localQty)) {
//       await updateQuantity(prod_id, qty);
//     }
//     setLocalQty({});

//     if (userId) {
//       navigate("/Bill");
//     } else {
//       setRedirectAfterLogin("/Bill");
//       setShowLogin(true);
//     }
//   };

//   return (
//     <>
//       <Layout />

//       <div className="container py-5">
//         <h2 className="fw-bold mb-4">Shopping Cart</h2>

//         <div className="row g-4">
//           <div className="col-md-8" ref={leftRef}>
//             {cartItems.length === 0 ? (
//               <p>Your cart is empty.</p>
//             ) : (
//               cartItems.map(item => {
//                 const qty = localQty[item.prod_id] ?? item.quantity;
//                 const total = qty * item.price;

//                 return (
//                   <div key={item.prod_id} className="card p-4 mb-3 shadow-sm">
//                     <div className="d-flex justify-content-between align-items-center">
//                       <div className="d-flex gap-3">
//                         <img
//                           src={`${BASE_URL}/${item.Product_image}`}
//                           alt={item.Product_name}
//                           style={{ width: 100, height: 100, objectFit: "contain" }}
//                         />

//                         <div>
//                           <h5 className="fontnamm">{item.Product_name}</h5>

//                           {/* <div
//                             className="d-flex align-items-center border rounded qty-box"
//                             style={{ width: 120, height: 40 }}
//                           >
//                             <button
//                               className="btn btn-light border-0 fw-bold qty-btn"
//                               style={{ width: 35 }}
//                               disabled={qty <= 1}
//                               onClick={() => changeQty(item.prod_id, qty - 1)}
//                             >
//                               −
//                             </button>

//                             <input
//                               type="text"
//                               value={qty}
//                               onChange={(e) => {
//                                 const val = e.target.value.replace(/\D/g, "");
//                                 if (val) changeQty(item.prod_id, Number(val));
//                               }}
//                               onBlur={() => handleBlur(item.prod_id)}
//                               className="form-control text-center border-0 qty-input"
//                               style={{
//                                 width: 50,
//                                 boxShadow: "none",
//                                 fontWeight: "600"
//                               }}
//                             />

//                             <button
//                               className="btn btn-light border-0 fw-bold qty-btn"
//                               style={{ width: 35 }}
//                               onClick={() => changeQty(item.prod_id, qty + 1)}
//                             >
//                               +
//                             </button>

//                             <button
//                               className="btn btn-link text-danger ms-3 p-0 delete-btn"
//                               onClick={() => removeItem(item.prod_id)}
//                             >
//                               Delete
//                             </button>
//                           </div> */}
//                           <div className="d-flex align-items-start gap-3 cart-actions">

//   {/* Quantity box */}
//   <div className="d-flex align-items-center border rounded qty-box">
//     <button
//       className="btn btn-light border-0 fw-bold qty-btn"
//       disabled={qty <= 1}
//       onClick={() => changeQty(item.prod_id, qty - 1)}
//     >
//       −
//     </button>

//     <input
//       type="text"
//       value={qty}
//       className="form-control text-center border-0 qty-input"
//       onChange={(e) => {
//         const val = e.target.value.replace(/\D/g, "");
//         if (val) changeQty(item.prod_id, Number(val));
//       }}
//       onBlur={() => handleBlur(item.prod_id)}
//     />

//     <button
//       className="btn btn-light border-0 fw-bold qty-btn"
//       onClick={() => changeQty(item.prod_id, qty + 1)}
//     >
//       +
//     </button>
//   </div>

//   {/* Delete button – qty box ke bahar */}
//   <button
//     className="btn btn-link text-danger p-0 delete-btn"
//     onClick={() => removeItem(item.prod_id)}
//   >
//     Delete
//   </button>

// </div>

//                         </div>
//                       </div>

//                       <b>₹{total.toFixed(2)}</b>
//                     </div>
//                   </div>
//                 );
//               })
//             )}

//             {cartItems.length > 0 && (
//               <div className="d-flex justify-content-between align-items-center border-top pt-3">
//                 <h5 className="fw-bold text-success">
//                   Subtotal: ₹{subtotal.toFixed(2)}
//                 </h5>

//                 <button
//                   className="btn text-light fw-bold px-md-4"
//                   style={{ background: "#24aeb1" }}
//                   onClick={handleProceed}
//                 >
//                   Proceed to Buy ({cartItems.length} items)
//                 </button>
//               </div>
//             )}
//           </div>

//           <VerticalScroll dynamicHeight={leftHeight} />
//         </div>
//       </div>
// <FooterNew/>
//       {/* <FooterCalendar /> */}
//     </>
//   );
// }

// export default Function_Cart10;

// 03-01-2026
// 03-01-2026 ye code sahi hai but add multple pak show nhi ho rahe the saize show ho rahe the niche same code main edit kar rahe hai pck ke liye
// import React, { useEffect, useRef, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import VerticalScroll from "./VerticalScroll";
// import axios from "axios";
// import { useCart } from "../../../Context/CartContext";
// import FooterNew from "../../Layout/FooterNew";
// import SEO from "../../SEO";

// const BASE_URL = "https://ecom.cyberathon.com";

// function Function_Cart10() {
//   const leftRef = useRef(null);
//   const debounceTimers = useRef({});

//   const [leftHeight, setLeftHeight] = useState(600);
//   const [cartItems, setCartItems] = useState([]);
//   const [localQty, setLocalQty] = useState({});
//   const [cartToken, setCartToken] = useState(null);
//   const [isMerging, setIsMerging] = useState(false); // ✅ NEW
// const [seoData, setSeoData] = useState({});
//  useEffect(() => {
//   const fetchSeo = async () => {
//     try {
//       const response = await axios.post(`${BASE_URL}/get_seo_by_page`, {
//         page_name: 'shopping_cart'   // <-- Important! page_name 'ebooks' rakho
//       });

//       if (response.data.status === 'true') {
//         const data = response.data.data;
//         setSeoData({
//           title: data.meta_title,
//           description: data.meta_description,
//           keywords: data.meta_keywords,
//           canonical: data.canonical_url,
//         });
//       }
//     } catch (error) {
//       console.error('SEO fetch error:', error);
//     }
//   };

//   fetchSeo();
// }, []);
//   const userId = sessionStorage.getItem("userId");
//   const navigate = useNavigate();
//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

//   /* ================= GUEST TOKEN ================= */
//   useEffect(() => {
//     if (!userId) {
//       let token = localStorage.getItem("cart_token");
//       if (!token) {
//         token = "guest_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
//         localStorage.setItem("cart_token", token);
//       }
//       setCartToken(token);
//     } else {
//       setCartToken(null);
//     }
//   }, [userId]);

//   /* ================= FETCH CART ================= */
//   const fetchCart = async () => {
//     const activeToken = cartToken || localStorage.getItem("cart_token");

//     if (!userId && !activeToken) return;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId || null,
//         cart_token: userId ? null : activeToken
//       });

//       console.log("📦 Fetch cart response:", res.data);

//       if (res.data.status) {
//         const items = res.data.cart_items.map(item => ({
//           ...item,
//           cart_id: Number(item.cart_id),
//           prod_id: Number(item.prod_id),
//           quantity: Number(item.cart_qty || item.qty), // ✅ Handle both field names
//            size_id: Number(item.size_id),
//   size: item.size,

//   price: Number(item.variant_price || item.current_price),
//   current_price: Number(item.variant_price || item.current_price)
//         }));

//         console.log("✅ Cart items:", items);
//         setCartItems(items);
//         setCartCount(items.length);
//       } else {
//         setCartItems([]);
//         setCartCount(0);
//       }
//     } catch (err) {
//       console.error("❌ Fetch cart error:", err);
//       setCartItems([]);
//       setCartCount(0);
//     }
//   };

//   useEffect(() => {
//     if ((userId || cartToken) && !isMerging) { // ✅ Don't fetch during merge
//       fetchCart();
//     }
//   }, [userId, cartToken, isMerging]);

//   /* ================= MERGE CART ON LOGIN ================= */
//   useEffect(() => {
//     const mergeCarts = async () => {
//       if (!userId || !cartToken || isMerging) return;

//       setIsMerging(true); // ✅ Prevent double execution

//       try {
//         console.log("🔄 Starting cart merge...");
//         console.log("📊 Current localQty:", localQty);

//         // 1️⃣ Clear all pending debounce timers
//         Object.keys(debounceTimers.current).forEach(prod_id => {
//           clearTimeout(debounceTimers.current[prod_id]);
//         });
//         debounceTimers.current = {};

//         // 2️⃣ ✅ CRITICAL: Save pending qty changes SYNCHRONOUSLY
//         if (Object.keys(localQty).length > 0) {
//           console.log("💾 Saving pending qty changes...");

//           for (const [prod_id, qty] of Object.entries(localQty)) {
//             console.log(`  → Saving prod_id=${prod_id}, qty=${qty}`);

//             try {
//               const updateRes = await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//                 user_id: null, // ⚠️ Guest mode
//                 cart_token: cartToken, // ✅ Use guest token
//                 prod_id: Number(prod_id),
//                 qty: Number(qty)
//               });

//               console.log(`  ✅ Update response for ${prod_id}:`, updateRes.data);
//             } catch (updateErr) {
//               console.error(`  ❌ Failed to update ${prod_id}:`, updateErr);
//             }
//           }

//           // ✅ Wait 500ms for backend to process
//           await new Promise(resolve => setTimeout(resolve, 500));
//           console.log("✅ All pending qty saved");
//         }

//         // 3️⃣ Merge guest cart to user cart
//         console.log("🔀 Calling merge_cart API...");
//         const mergeResponse = await axios.post(`${BASE_URL}/index.php/Api/merge_cart`, {
//           user_id: userId,
//           cart_token: cartToken
//         });

//         console.log("✅ Merge response:", mergeResponse.data);

//         // 4️⃣ Cleanup
//         localStorage.removeItem("cart_token");
//         setCartToken(null);
//         setLocalQty({});
//         console.log("🧹 Cleanup complete");

//         // 5️⃣ Wait and fetch updated cart
//         await new Promise(resolve => setTimeout(resolve, 300));
//         setIsMerging(false);
//         await fetchCart();
//         console.log("✅ Cart merge complete!");

//       } catch (err) {
//         console.error("❌ Merge failed:", err);
//         setIsMerging(false);
//         fetchCart();
//       }
//     };

//     mergeCarts();
//   }, [userId]); // ✅ Only depend on userId

//   /* ================= HEIGHT ================= */
//   useEffect(() => {
//     if (leftRef.current) {
//       setLeftHeight(leftRef.current.scrollHeight + 20);
//     }
//   }, [cartItems, localQty]);

//   /* ================= UPDATE QTY API ================= */
//   const updateQuantity = async (prod_id, qty) => {
//     try {
//       console.log(`🔄 Updating qty: prod_id=${prod_id}, qty=${qty}`);

//       // const response = await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//       //   user_id: userId || null,
//       //   cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token")),
//       //   prod_id: Number(prod_id),
//       //   qty: Number(qty)
//       // });

//       const item = cartItems.find(i => i.prod_id === prod_id);

// const response = await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//   user_id: userId || null,
//   cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token")),
//   prod_id: Number(prod_id),
//   size_id: Number(item?.size_id),
//   qty: Number(qty)
// });
//       console.log("✅ Update response:", response.data);

//       // ✅ Only fetch if not merging
//       if (!isMerging) {
//         await fetchCart();
//       }
//     } catch (err) {
//       console.error("❌ Update quantity error:", err);
//     }
//   };

//   /* ================= CHANGE QTY (DEBOUNCE) ================= */
//   const changeQty = (prod_id, qty) => {
//     if (qty < 1) return;

//     console.log(`📝 Changing qty: prod_id=${prod_id}, qty=${qty}`);
//     setLocalQty(prev => ({ ...prev, [prod_id]: qty }));

//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//     }

//     debounceTimers.current[prod_id] = setTimeout(() => {
//       updateQuantity(prod_id, qty);
//     }, 500);
//   };

//   /* ================= BLUR ================= */
//   const handleBlur = (prod_id) => {
//     if (debounceTimers.current[prod_id]) {
//       clearTimeout(debounceTimers.current[prod_id]);
//       delete debounceTimers.current[prod_id];
//     }

//     setLocalQty(prev => {
//       const copy = { ...prev };
//       delete copy[prod_id];
//       return copy;
//     });
//   };

//   /* ================= REMOVE ================= */
//   const removeItem = async (prod_id) => {
//     try {
//       const item = cartItems.find(i => i.prod_id === prod_id);
//       console.log("🔴 DELETE - cart_id:", item?.cart_id, "prod_id:", prod_id);

//       if (!item || !item.cart_id) {
//         console.error("❌ cart_id not found!");
//         return;
//       }

//       if (debounceTimers.current[prod_id]) {
//         clearTimeout(debounceTimers.current[prod_id]);
//         delete debounceTimers.current[prod_id];
//       }

//       setLocalQty(prev => {
//         const copy = { ...prev };
//         delete copy[prod_id];
//         return copy;
//       });

//       setCartItems(prev => prev.filter(item => item.prod_id !== prod_id));
//       setCartCount(prev => Math.max(prev - 1, 0));

//       const payload = {
//         cart_id: Number(item.cart_id),
//         user_id: userId || null,
//         cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token"))
//       };

//       console.log("📤 DELETE request:", payload);
//       const response = await axios.post(`${BASE_URL}/index.php/Api/delete_cart`, payload);
//       console.log("📥 DELETE response:", response.data);

//       if (!response.data.status) {
//         console.error("❌ Backend delete failed");
//         fetchCart();
//       }
//     } catch (err) {
//       console.error("❌ Delete error:", err);
//       fetchCart();
//     }
//   };

//   /* ================= SUBTOTAL ================= */
//   const subtotal = cartItems.reduce((sum, item) => {
//     const qty = localQty[item.prod_id] ?? item.quantity;
//     // return sum + qty * item.price;
//     return sum + qty * item.current_price;
//   }, 0);

//   /* ================= PROCEED ================= */
//   const handleProceed = async () => {
//     try {
//       console.log("🚀 Proceed clicked, saving pending qty...");

//       for (const [prod_id, qty] of Object.entries(localQty)) {
//         await updateQuantity(Number(prod_id), qty);
//       }

//       setLocalQty({});
//       console.log("✅ All qty saved");

//       if (userId) {
//         navigate("/Bill");
//       } else {
//         setRedirectAfterLogin("/Bill");
//         setShowLogin(true);
//       }
//     } catch (err) {
//       console.error("❌ Proceed error:", err);
//     }
//   };

// const getYoutubeId = (url) => {
//   if (!url) return "";
//   if (url.includes("watch?v=")) {
//     return url.split("v=")[1].split("&")[0];
//   }
//   if (url.includes("youtu.be/")) {
//     return url.split("youtu.be/")[1].split("?")[0];
//   }
//   if (url.includes("embed/")) {
//     return url.split("embed/")[1].split("?")[0];
//   }
//   return "";
// };
// const renderImage = (item) => {
//   if (item.product_type === "ebook") {
//     return (
//       <iframe
//         src={`${BASE_URL}/${item.pdf_file}#page=1&toolbar=0&navpanes=0`}
//         style={{ width: 100, height: 100, border: "none" }}
//         title="ebook-preview"
//       />
//     );
//   }

//   if (item.product_type === "coursesection") {
//     return (
//       <div style={{ position: "relative" }}>
//         <img
//           src={`https://img.youtube.com/vi/${getYoutubeId(item.video_file)}/hqdefault.jpg`}
//           style={{ width: 100, height: 100, objectFit: "cover", borderRadius: "8px" }}
//           alt="course"
//         />
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             fontSize: "20px",
//             color: "white",
//             background: "rgba(0,0,0,0.6)",
//             borderRadius: "50%",
//             padding: "6px 10px"
//           }}
//         >
//           ▶
//         </div>
//       </div>
//     );
//   }

//   // ✅ product
//   return (
//     <img
//       src={`${BASE_URL}/${
//         Array.isArray(item.Product_image)
//           ? item.Product_image[0]
//           : item.Product_image
//       }`}
//       alt={item.Product_name}
//       style={{ width: 100, height: 100, objectFit: "contain" }}
//     />
//   );
// };

// const getItemLink = (item) => {
//   if (item.product_type === "product") {
//     return `/DetailsSection3/${item.prod_id}`;
//   }

//   if (item.product_type === "ebook") {
//     return `/EbookDetail/${item.prod_id}`;
//   }

//   if (item.product_type === "coursesection") {
//     return `/coursesectiondetail/${item.prod_id}`;
//   }

//   return null;
// };

//   return (
//     <>
//     <SEO
//       title={seoData.title || "ShopIndia | Ebooks"}
//       description={seoData.description || "Explore our collection of ebooks on ShopIndia."}
//       keywords={seoData.keywords || "ebooks, ShopIndia, books, pdf"}
//       canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
//     />
//       <Layout />

//       <div className="container py-5">
//         <h2 className="fw-bold mb-4">Shopping Cart</h2>

//         <div className="row g-4">
//           <div className="col-md-8" ref={leftRef}>
//             {cartItems.length === 0 ? (
//               <p>Your cart is empty.</p>
//             ) : (
//               cartItems.map(item => {
//                 const itemLink = getItemLink(item);
//                 const qty = localQty[item.prod_id] ?? item.quantity;
//                 // const total = qty * item.price;
//                 const total = qty * item.current_price;
// const videoId = getYoutubeId(item.video_file);
// const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
// console.log("VIDEO URL:", item.video_file);
// console.log("VIDEO ID:", getYoutubeId(item.video_file));
//                 return (
//                   <div key={item.prod_id} className="card p-4 mb-3 shadow-sm">
//                     <div className="d-flex justify-content-between align-items-center">
//                       <div className="d-flex gap-3">
//                         {/* <Link to={`/DetailsSection3/${item.prod_id}`}>

// {item.product_type === "ebook" ? (
//   <iframe
//     src={`${BASE_URL}/${item.pdf_file}#page=1&toolbar=0&navpanes=0`}
//     style={{ width: 100, height: 100, border: "none" }}
//     title="ebook-preview"
//   />
// ) : item.product_type === "coursesection" ? (

//   <div style={{ position: "relative" }}>
//     <img
//       src={`https://img.youtube.com/vi/${getYoutubeId(item.video)}/hqdefault.jpg`}
//       style={{ width: 100, height: 100, objectFit: "cover", borderRadius: "8px" }}
//       alt="course"
//     />

//     <div
//       style={{
//         position: "absolute",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         fontSize: "20px",
//         color: "white",
//         background: "rgba(0,0,0,0.6)",
//         borderRadius: "50%",
//         padding: "6px 10px"
//       }}
//     >
//       ▶
//     </div>
//   </div>
// ) : (
//   <img
//     src={`${BASE_URL}/${
//       Array.isArray(item.Product_image)
//         ? item.Product_image[0]
//         : item.Product_image
//     }`}
//     alt={item.Product_name}
//     style={{ width: 100, height: 100, objectFit: "contain" }}
//   />
// )}

//                         </Link> */}
//                         {/* {item.product_type === "product" ? (
//   <Link to={`/DetailsSection3/${item.prod_id}`}>
//     {renderImage(item)}
//   </Link>
// ) : (
//   renderImage(item)
// )} */}
// {itemLink ? (
//   <Link to={itemLink}>
//     {renderImage(item)}
//   </Link>
// ) : (
//   renderImage(item)
// )}

//                         <div>
//                           <h5 className="fontnamm">
//   {/* {item.pdf_name || item.Product_name} */}
//   {item.pdf_name || item.heading || item.Product_name}
//   {item.size && (
//   <div style={{ fontSize: "13px", color: "#777" }}>
//     Size: {item.size} mm
//   </div>
// )}
// </h5>
//                           <div className="d-flex align-items-start gap-3 cart-actions">
//                             <div className="d-flex align-items-center border rounded qty-box">
//                               <button
//                                 className="btn btn-light border-0 fw-bold qty-btn"
//                                 disabled={qty <= 1}
//                                 onClick={() => changeQty(item.prod_id, qty - 1)}
//                               >
//                                 −
//                               </button>

//                               <input
//                                 type="text"
//                                 value={qty}
//                                 className="form-control text-center border-0 qty-input"
//                                 onChange={(e) => {
//                                   const val = e.target.value.replace(/\D/g, "");
//                                   if (val) changeQty(item.prod_id, Number(val));
//                                 }}
//                                 onBlur={() => handleBlur(item.prod_id)}
//                               />

//                               <button
//                                 className="btn btn-light border-0 fw-bold qty-btn"
//                                 onClick={() => changeQty(item.prod_id, qty + 1)}
//                               >
//                                 +
//                               </button>
//                             </div>

//                             <button
//                               className="btn btn-link text-danger p-0 delete-btn"
//                               onClick={() => removeItem(item.prod_id)}
//                             >
//                               Delete
//                             </button>
//                           </div>
//                         </div>
//                       </div>

//                       <b>₹{total.toFixed(2)}</b>
//                     </div>
//                   </div>
//                 );
//               })
//             )}

//             {cartItems.length > 0 && (
//               <div className="d-flex justify-content-between align-items-center border-top pt-3">
//                 <h5 className="fw-bold text-success">
//                   Subtotal: ₹{subtotal.toFixed(2)}
//                 </h5>

//                 <button
//                   className="btn text-light fw-bold px-md-4"
//                   style={{ background: "#24aeb1" }}
//                   onClick={handleProceed}
//                 >
//                   Proceed to Buy ({cartItems.length} items)
//                 </button>
//               </div>
//             )}
//           </div>

//           <VerticalScroll dynamicHeight={leftHeight} />
//         </div>
//       </div>

//       <FooterNew/>
//     </>
//   );
// }

// export default Function_Cart10;




// 10-Aug-2026 uapr wala code hi hai bas add multple pack show nhi ho rahe the utna edit kiya hai
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../Layout/Layout";
import VerticalScroll from "./VerticalScroll";
import axios from "axios";
import { useCart } from "../../../Context/CartContext";
import FooterNew from "../../Layout/FooterNew";
import SEO from "../../SEO";

const BASE_URL = "https://ecom.cyberathon.com";

function Function_Cart10() {
  const leftRef = useRef(null);
  const debounceTimers = useRef({});

  const [leftHeight, setLeftHeight] = useState(600);
  const [cartItems, setCartItems] = useState([]);
  const [localQty, setLocalQty] = useState({});
  const [cartToken, setCartToken] = useState(null);
  const [isMerging, setIsMerging] = useState(false); // ✅ NEW
  const [seoData, setSeoData] = useState({});
  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/get_seo_by_page`, {
          page_name: "shopping_cart", // <-- Important! page_name 'ebooks' rakho
        });

        if (response.data.status === "true") {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error("SEO fetch error:", error);
      }
    };

    fetchSeo();
  }, []);
  const userId = sessionStorage.getItem("userId");
  const navigate = useNavigate();
  const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

  /* ================= GUEST TOKEN ================= */
  useEffect(() => {
    if (!userId) {
      let token = localStorage.getItem("cart_token");
      if (!token) {
        token =
          "guest_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
        localStorage.setItem("cart_token", token);
      }
      setCartToken(token);
    } else {
      setCartToken(null);
    }
  }, [userId]);

  /* ================= FETCH CART ================= */
  const fetchCart = async () => {
    const activeToken = cartToken || localStorage.getItem("cart_token");

    if (!userId && !activeToken) return;

    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
        user_id: userId || null,
        cart_token: userId ? null : activeToken,
      });

      console.log("📦 Fetch cart response:", res.data);

      if (res.data.status) {
        // const items = res.data.cart_items.map(item => ({
        //   ...item,
        //   cart_id: Number(item.cart_id),
        //   prod_id: Number(item.prod_id),
        //   quantity: Number(item.cart_qty || item.qty), // ✅ Handle both field names
        //   size_id: Number(item.size_id),
        //   size: item.size,

        //   price: Number(item.variant_price || item.current_price),
        //   current_price: Number(item.variant_price || item.current_price)
        // }));

        const items = res.data.cart_items.map((item) => {
          // ✅ FIX: Parse selected_quantity_set (string ya object aa sakta hai)
          let parsedQtySet = item.selected_quantity_set;
          if (typeof parsedQtySet === "string") {
            try {
              parsedQtySet = JSON.parse(parsedQtySet);
            } catch {
              parsedQtySet = null;
            }
          }

          return {
            ...item,
            cart_id: Number(item.cart_id),
            prod_id: Number(item.prod_id),
            quantity: Number(item.cart_qty || item.qty),
            size_id: Number(item.size_id),
            size: item.size,
            price: Number(item.variant_price || item.current_price),
            current_price: Number(item.variant_price || item.current_price),
            selected_quantity_set: parsedQtySet,
            price_type: item.price_type || "simple",
          };
        });

        console.log("✅ Cart items:", items);
        setCartItems(items);
        setCartCount(items.length);
      } else {
        setCartItems([]);
        setCartCount(0);
      }
    } catch (err) {
      console.error("❌ Fetch cart error:", err);
      setCartItems([]);
      setCartCount(0);
    }
  };

  useEffect(() => {
    if ((userId || cartToken) && !isMerging) {
      // ✅ Don't fetch during merge
      fetchCart();
    }
  }, [userId, cartToken, isMerging]);

  /* ================= MERGE CART ON LOGIN ================= */
  useEffect(() => {
    const mergeCarts = async () => {
      if (!userId || !cartToken || isMerging) return;

      setIsMerging(true); // ✅ Prevent double execution

      try {
        console.log("🔄 Starting cart merge...");
        console.log("📊 Current localQty:", localQty);

        // 1️⃣ Clear all pending debounce timers
        Object.keys(debounceTimers.current).forEach((prod_id) => {
          clearTimeout(debounceTimers.current[prod_id]);
        });
        debounceTimers.current = {};

        // 2️⃣ ✅ CRITICAL: Save pending qty changes SYNCHRONOUSLY
        // if (Object.keys(localQty).length > 0) {
        //   console.log("💾 Saving pending qty changes...");

        //   for (const [prod_id, qty] of Object.entries(localQty)) {
        //     console.log(`  → Saving prod_id=${prod_id}, qty=${qty}`);

        //     try {
        //       const updateRes = await axios.post(
        //         `${BASE_URL}/index.php/Api/update_cart`,
        //         {
        //           user_id: null, // ⚠️ Guest mode
        //           cart_token: cartToken, // ✅ Use guest token
        //           prod_id: Number(prod_id),
        //           qty: Number(qty),
        //         },
        //       );

        //       console.log(
        //         `  ✅ Update response for ${prod_id}:`,
        //         updateRes.data,
        //       );
        //     } catch (updateErr) {
        //       console.error(`  ❌ Failed to update ${prod_id}:`, updateErr);
        //     }
        //   }

                if (Object.keys(localQty).length > 0) {
          console.log("💾 Saving pending qty changes...");

          for (const [cartId, qty] of Object.entries(localQty)) {
            // ✅ FIX: cart_id se item dhundho prod_id nahi
            const cartItem = cartItems.find(i => String(i.cart_id) === String(cartId));
            if (!cartItem) continue;

            console.log(`  → Saving cart_id=${cartId}, prod_id=${cartItem.prod_id}, qty=${qty}`);

            try {
              const updateRes = await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
                user_id: null,
                cart_token: cartToken,
                cart_id: Number(cartId),
                prod_id: Number(cartItem.prod_id),
                size_id: Number(cartItem.size_id) || null,
                qty: Number(qty)
              });

              console.log(`  ✅ Update response for ${cartId}:`, updateRes.data);
            } catch (updateErr) {
              console.error(`  ❌ Failed to update ${cartId}:`, updateErr);
            }
          }

          // ✅ Wait 500ms for backend to process
          await new Promise((resolve) => setTimeout(resolve, 500));
          console.log("✅ All pending qty saved");
        }

        // 3️⃣ Merge guest cart to user cart
        console.log("🔀 Calling merge_cart API...");
        const mergeResponse = await axios.post(
          `${BASE_URL}/index.php/Api/merge_cart`,
          {
            user_id: userId,
            cart_token: cartToken,
          },
        );

        console.log("✅ Merge response:", mergeResponse.data);

        // 4️⃣ Cleanup
        localStorage.removeItem("cart_token");
        setCartToken(null);
        setLocalQty({});
        console.log("🧹 Cleanup complete");

        // 5️⃣ Wait and fetch updated cart
        await new Promise((resolve) => setTimeout(resolve, 300));
        setIsMerging(false);
        await fetchCart();
        console.log("✅ Cart merge complete!");
      } catch (err) {
        console.error("❌ Merge failed:", err);
        setIsMerging(false);
        fetchCart();
      }
    };

    mergeCarts();
  }, [userId]); // ✅ Only depend on userId

  /* ================= HEIGHT ================= */
  useEffect(() => {
    if (leftRef.current) {
      setLeftHeight(leftRef.current.scrollHeight + 20);
    }
  }, [cartItems, localQty]);

  /* ================= UPDATE QTY API ================= */
  // const updateQuantity = async (prod_id, qty) => {
  //   try {
  //     console.log(`🔄 Updating qty: prod_id=${prod_id}, qty=${qty}`);

  //     // const response = await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
  //     //   user_id: userId || null,
  //     //   cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token")),
  //     //   prod_id: Number(prod_id),
  //     //   qty: Number(qty)
  //     // });

  //     const item = cartItems.find((i) => i.prod_id === prod_id);

  //     const response = await axios.post(
  //       `${BASE_URL}/index.php/Api/update_cart`,
  //       {
  //         user_id: userId || null,
  //         cart_token: userId
  //           ? null
  //           : cartToken || localStorage.getItem("cart_token"),
  //         prod_id: Number(prod_id),
  //         size_id: Number(item?.size_id),
  //         qty: Number(qty),
  //       },
  //     );
  //     console.log("✅ Update response:", response.data);

  //     // ✅ Only fetch if not merging
  //     if (!isMerging) {
  //       await fetchCart();
  //     }
  //   } catch (err) {
  //     console.error("❌ Update quantity error:", err);
  //   }
  // };

  // /* ================= CHANGE QTY (DEBOUNCE) ================= */
  // const changeQty = (prod_id, qty) => {
  //   if (qty < 1) return;

  //   console.log(`📝 Changing qty: prod_id=${prod_id}, qty=${qty}`);
  //   setLocalQty((prev) => ({ ...prev, [prod_id]: qty }));

  //   if (debounceTimers.current[prod_id]) {
  //     clearTimeout(debounceTimers.current[prod_id]);
  //   }

  //   debounceTimers.current[prod_id] = setTimeout(() => {
  //     updateQuantity(prod_id, qty);
  //   }, 500);
  // };

  // /* ================= BLUR ================= */
  // const handleBlur = (prod_id) => {
  //   if (debounceTimers.current[prod_id]) {
  //     clearTimeout(debounceTimers.current[prod_id]);
  //     delete debounceTimers.current[prod_id];
  //   }

  //   setLocalQty((prev) => {
  //     const copy = { ...prev };
  //     delete copy[prod_id];
  //     return copy;
  //   });
  // };

  // /* ================= REMOVE ================= */
  // const removeItem = async (prod_id) => {
  //   try {
  //     const item = cartItems.find((i) => i.prod_id === prod_id);
  //     console.log("🔴 DELETE - cart_id:", item?.cart_id, "prod_id:", prod_id);

  //     if (!item || !item.cart_id) {
  //       console.error("❌ cart_id not found!");
  //       return;
  //     }

  //     if (debounceTimers.current[prod_id]) {
  //       clearTimeout(debounceTimers.current[prod_id]);
  //       delete debounceTimers.current[prod_id];
  //     }

  //     setLocalQty((prev) => {
  //       const copy = { ...prev };
  //       delete copy[prod_id];
  //       return copy;
  //     });

  //     setCartItems((prev) => prev.filter((item) => item.prod_id !== prod_id));
  //     setCartCount((prev) => Math.max(prev - 1, 0));

  //     const payload = {
  //       cart_id: Number(item.cart_id),
  //       user_id: userId || null,
  //       cart_token: userId
  //         ? null
  //         : cartToken || localStorage.getItem("cart_token"),
  //     };

  //     console.log("📤 DELETE request:", payload);
  //     const response = await axios.post(
  //       `${BASE_URL}/index.php/Api/delete_cart`,
  //       payload,
  //     );
  //     console.log("📥 DELETE response:", response.data);

  //     if (!response.data.status) {
  //       console.error("❌ Backend delete failed");
  //       fetchCart();
  //     }
  //   } catch (err) {
  //     console.error("❌ Delete error:", err);
  //     fetchCart();
  //   }
  // };


  /* ================= UPDATE QTY API ================= */
  const updateQuantity = async (cartId, qty) => {
    try {
      console.log(`🔄 Updating qty: cart_id=${cartId}, qty=${qty}`);

      const item = cartItems.find(i => i.cart_id === cartId);

      const response = await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
        user_id: userId || null,
        cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token")),
        cart_id: Number(cartId),
        prod_id: Number(item?.prod_id),
        size_id: Number(item?.size_id) || null,
        qty: Number(qty)
      });
      console.log("✅ Update response:", response.data);

      if (!isMerging) {
        await fetchCart();
      }
    } catch (err) {
      console.error("❌ Update quantity error:", err);
    }
  };

  /* ================= CHANGE QTY (DEBOUNCE) ================= */
  const changeQty = (cartId, qty) => {
    if (qty < 1) return;

    console.log(`📝 Changing qty: cart_id=${cartId}, qty=${qty}`);
    setLocalQty(prev => ({ ...prev, [cartId]: qty }));

    if (debounceTimers.current[cartId]) {
      clearTimeout(debounceTimers.current[cartId]);
    }

    debounceTimers.current[cartId] = setTimeout(() => {
      updateQuantity(cartId, qty);
    }, 500);
  };

  /* ================= BLUR ================= */
  const handleBlur = (cartId) => {
    if (debounceTimers.current[cartId]) {
      clearTimeout(debounceTimers.current[cartId]);
      delete debounceTimers.current[cartId];
    }

    setLocalQty(prev => {
      const copy = { ...prev };
      delete copy[cartId];
      return copy;
    });
  };

  /* ================= REMOVE ================= */
  const removeItem = async (cartId) => {
    try {
      const item = cartItems.find(i => i.cart_id === cartId);
      console.log("🔴 DELETE - cart_id:", cartId, "prod_id:", item?.prod_id);

      if (!item || !item.cart_id) {
        console.error("❌ cart_id not found!");
        return;
      }

      if (debounceTimers.current[cartId]) {
        clearTimeout(debounceTimers.current[cartId]);
        delete debounceTimers.current[cartId];
      }

      setLocalQty(prev => {
        const copy = { ...prev };
        delete copy[cartId];
        return copy;
      });

      // ✅ FIX: cart_id se filter karo, prod_id se NAHI
      // Pehle: prod_id se filter hota tha → same product ke SABHI variants delete ho jate the
      setCartItems(prev => prev.filter(item => item.cart_id !== cartId));
      setCartCount(prev => Math.max(prev - 1, 0));

      const payload = {
        cart_id: Number(item.cart_id),
        user_id: userId || null,
        cart_token: userId ? null : (cartToken || localStorage.getItem("cart_token"))
      };

      console.log("📤 DELETE request:", payload);
      const response = await axios.post(`${BASE_URL}/index.php/Api/delete_cart`, payload);
      console.log("📥 DELETE response:", response.data);

      if (!response.data.status) {
        console.error("❌ Backend delete failed");
        fetchCart();
      }
    } catch (err) {
      console.error("❌ Delete error:", err);
      fetchCart();
    }
  };



  /* ================= SUBTOTAL ================= */
  // const subtotal = cartItems.reduce((sum, item) => {
  //   const qty = localQty[item.prod_id] ?? item.quantity;
  //   // return sum + qty * item.price;
  //   return sum + qty * item.current_price;
  // }, 0);

    const subtotal = cartItems.reduce((sum, item) => {
    const qty = localQty[item.cart_id] ?? item.quantity;
    return sum + qty * item.current_price;
  }, 0);

  /* ================= PROCEED ================= */
  const handleProceed = async () => {
    try {
      console.log("🚀 Proceed clicked, saving pending qty...");

      // for (const [prod_id, qty] of Object.entries(localQty)) {
      //   await updateQuantity(Number(prod_id), qty);
      // }

      for (const [cartId, qty] of Object.entries(localQty)) {
        await updateQuantity(Number(cartId), qty);
      }

      setLocalQty({});
      console.log("✅ All qty saved");

      if (userId) {
        navigate("/Bill");
      } else {
        setRedirectAfterLogin("/Bill");
        setShowLogin(true);
      }
    } catch (err) {
      console.error("❌ Proceed error:", err);
    }
  };

  const getYoutubeId = (url) => {
    if (!url) return "";
    if (url.includes("watch?v=")) {
      return url.split("v=")[1].split("&")[0];
    }
    if (url.includes("youtu.be/")) {
      return url.split("youtu.be/")[1].split("?")[0];
    }
    if (url.includes("embed/")) {
      return url.split("embed/")[1].split("?")[0];
    }
    return "";
  };
  const renderImage = (item) => {
    if (item.product_type === "ebook") {
      return (
        <iframe
          src={`${BASE_URL}/${item.pdf_file}#page=1&toolbar=0&navpanes=0`}
          style={{ width: 100, height: 100, border: "none" }}
          title="ebook-preview"
        />
      );
    }

    if (item.product_type === "coursesection") {
      return (
        <div style={{ position: "relative" }}>
          <img
            src={`https://img.youtube.com/vi/${getYoutubeId(item.video_file)}/hqdefault.jpg`}
            style={{
              width: 100,
              height: 100,
              objectFit: "cover",
              borderRadius: "8px",
            }}
            alt="course"
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "20px",
              color: "white",
              background: "rgba(0,0,0,0.6)",
              borderRadius: "50%",
              padding: "6px 10px",
            }}
          >
            ▶
          </div>
        </div>
      );
    }

    // ✅ product
    return (
      <img
        src={`${BASE_URL}/${
          Array.isArray(item.Product_image)
            ? item.Product_image[0]
            : item.Product_image
        }`}
        alt={item.Product_name}
        style={{ width: 100, height: 100, objectFit: "contain" }}
      />
    );
  };

  const getItemLink = (item) => {
    if (item.product_type === "product") {
      return `/DetailsSection3/${item.prod_id}`;
    }

    if (item.product_type === "ebook") {
      return `/EbookDetail/${item.prod_id}`;
    }

    if (item.product_type === "coursesection") {
      return `/coursesectiondetail/${item.prod_id}`;
    }

    return null;
  };

  return (
    <>
      <SEO
        title={seoData.title || "ShopIndia | Ebooks"}
        description={
          seoData.description ||
          "Explore our collection of ebooks on ShopIndia."
        }
        keywords={seoData.keywords || "ebooks, ShopIndia, books, pdf"}
        canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
      />
      <Layout />

      <div className="container py-5">
        <h2 className="fw-bold mb-4">Shopping Cart</h2>

        <div className="row g-4">
          <div className="col-md-8" ref={leftRef}>
            {cartItems.length === 0 ? (
              <p>Your cart is empty.</p>
            ) : (
              cartItems.map((item) => {
                const itemLink = getItemLink(item);
                // const qty = localQty[item.prod_id] ?? item.quantity;
                const qty = localQty[item.cart_id] ?? item.quantity;
                // const total = qty * item.price;
                const total = qty * item.current_price;
                const videoId = getYoutubeId(item.video_file);
                const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                console.log("VIDEO URL:", item.video_file);
                console.log("VIDEO ID:", getYoutubeId(item.video_file));
                return (
                  // <div key={item.prod_id} className="card p-4 mb-3 shadow-sm">
                    <div key={item.cart_id} className="card p-4 mb-3 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-3">
                        {/* <Link to={`/DetailsSection3/${item.prod_id}`}>
                      

{item.product_type === "ebook" ? (
  <iframe
    src={`${BASE_URL}/${item.pdf_file}#page=1&toolbar=0&navpanes=0`}
    style={{ width: 100, height: 100, border: "none" }}
    title="ebook-preview"
  />
) : item.product_type === "coursesection" ? (

  <div style={{ position: "relative" }}>
    <img
      src={`https://img.youtube.com/vi/${getYoutubeId(item.video)}/hqdefault.jpg`}
      style={{ width: 100, height: 100, objectFit: "cover", borderRadius: "8px" }}
      alt="course"
    />
    
 
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "20px",
        color: "white",
        background: "rgba(0,0,0,0.6)",
        borderRadius: "50%",
        padding: "6px 10px"
      }}
    >
      ▶
    </div>
  </div>
) : (
  <img
    src={`${BASE_URL}/${
      Array.isArray(item.Product_image)
        ? item.Product_image[0]
        : item.Product_image
    }`}
    alt={item.Product_name}
    style={{ width: 100, height: 100, objectFit: "contain" }}
  />
)}

                        </Link> */}
                        {/* {item.product_type === "product" ? (
  <Link to={`/DetailsSection3/${item.prod_id}`}>
    {renderImage(item)}
  </Link>
) : (
  renderImage(item)
)} */}
                        {itemLink ? (
                          <Link to={itemLink}>{renderImage(item)}</Link>
                        ) : (
                          renderImage(item)
                        )}

                        <div>
                          {/* <h5 className="fontnamm">
                            {item.pdf_name || item.heading || item.Product_name}
                            {item.size && (
                              <div style={{ fontSize: "13px", color: "#777" }}>
                                Size: {item.size} mm
                              </div>
                            )}
                          </h5> */}

                          <h5 className="fontnamm">
                            {item.pdf_name || item.heading || item.Product_name}
                            {item.size && (
                              <div style={{ fontSize: "13px", color: "#777" }}>
                                Size: {item.size} mm
                              </div>
                            )}
                            {item.price_type === "quantity_set" &&
                              item.selected_quantity_set && (
                                <div
                                  style={{
                                    fontSize: "13px",
                                    color: "#24aeb1",
                                    fontWeight: "500",
                                  }}
                                >
                                  {" "}
                                  {item.selected_quantity_set.label ||
                                    `${item.selected_quantity_set.quantity} Pc`}
                                </div>
                              )}
                          </h5>
                          <div className="d-flex align-items-start gap-3 cart-actions">
                            <div className="d-flex align-items-center border rounded qty-box">
                              {/* <button
                                className="btn btn-light border-0 fw-bold qty-btn"
                                disabled={qty <= 1}
                                onClick={() => changeQty(item.prod_id, qty - 1)}
                              >
                                −
                              </button>

                              <input
                                type="text"
                                value={qty}
                                className="form-control text-center border-0 qty-input"
                                onChange={(e) => {
                                  const val = e.target.value.replace(/\D/g, "");
                                  if (val) changeQty(item.prod_id, Number(val));
                                }}
                                onBlur={() => handleBlur(item.prod_id)}
                              />

                              <button
                                className="btn btn-light border-0 fw-bold qty-btn"
                                onClick={() => changeQty(item.prod_id, qty + 1)}
                              >
                                +
                              </button>
                            </div>

                            <button
                              className="btn btn-link text-danger p-0 delete-btn"
                              onClick={() => removeItem(item.prod_id)}
                            >
                              Delete
                            </button> */}

                            <button
                                className="btn btn-light border-0 fw-bold qty-btn"
                                                               disabled={qty <= 1}
                                onClick={() => changeQty(item.cart_id, qty - 1)}
                              >
                                −
                              </button>

                              <input
                                type="text"
                                value={qty}
                                className="form-control text-center border-0 qty-input"
                                onChange={(e) => {
                                  const val = e.target.value.replace(/\D/g, "");
                                  if (val) changeQty(item.cart_id, Number(val));
                                }}
                                onBlur={() => handleBlur(item.cart_id)}
                              />

                              <button
                                className="btn btn-light border-0 fw-bold qty-btn"
                                onClick={() => changeQty(item.cart_id, qty + 1)}
                              >
                                +
                              </button>
                            </div>

                            <button
                              className="btn btn-link text-danger p-0 delete-btn"
                              onClick={() => removeItem(item.cart_id)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>

                      <b>₹{total.toFixed(2)}</b>
                    </div>
                  </div>
                );
              })
            )}

            {cartItems.length > 0 && (
              <div className="d-flex justify-content-between align-items-center border-top pt-3">
                <h5 className="fw-bold text-success">
                  Subtotal: ₹{subtotal.toFixed(2)}
                </h5>

                <button
                  className="btn text-light fw-bold px-md-4"
                  style={{ background: "#24aeb1" }}
                  onClick={handleProceed}
                >
                  Proceed to Buy ({cartItems.length} items)
                </button>
              </div>
            )}
          </div>

          <VerticalScroll dynamicHeight={leftHeight} />
        </div>
      </div>

      <FooterNew />
    </>
  );
}

export default Function_Cart10;
